import { render, staticRenderFns } from "./MerchantSettings.vue?vue&type=template&id=68902b29&scoped=true"
import script from "./MerchantSettings.vue?vue&type=script&lang=js"
export * from "./MerchantSettings.vue?vue&type=script&lang=js"
import style0 from "./MerchantSettings.vue?vue&type=style&index=0&id=68902b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68902b29",
  null
  
)

export default component.exports